import Constants from './Constants';

// Which of Constants.ANNOUNCEMENTS apply on a given day, and to whom. Dates are
// "YYYY-MM-DD" strings, which compare correctly as plain strings.
class Announcements {
  static isLive = (announcement, date) => {
    return date >= announcement.startDate
      && (!announcement.endDate || date <= announcement.endDate);
  }

  static getLive = (date) => {
    return Constants.ANNOUNCEMENTS.filter((announcement) => Announcements.isLive(announcement, date));
  }

  // The live announcements a player has yet to see, in the order they are listed.
  static getPending = (date, seen) => {
    return Announcements.getLive(date).filter((announcement) => !seen.includes(announcement.id));
  }
}

export default Announcements;
